export class PurchaseRequisitionApproveDeclineReworkCompletionData {
    constructor(
        public readonly approved: boolean,
        public readonly rework?: boolean,
        public readonly explanation?: string
    ) {}
}
